import React from "react";
import moment from "moment";
import axios from "axios";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import CreatePromocode from "./CreatePromocode";
import ModalOverlay from "components/UI/ModalOverlay";
import theme from "../../../Theme/theme";
import SearchBox from "components/SearchBox";
import Users from "../UsersScreen/Users";
import SingleUser from "../UsersScreen/SingleUser";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";
import { submit, dateDiffInDays, getExpiryDuration, sortDataByDateWithNullFirst } from '../../../common/Utils'
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Constants } from "../../../common/constants";
import Pagination from "components/Pagination";

const EDIT_TEXT = "Edit"
const DELETE_TEXT = "Delete"
const AVAILABLE_TEXT = "ACTIVE"
const UN_AVAILABLE_TEXT = "EXPIRED"
const DELETE_ALERT_TEXT = "Are you sure you want to delete this promo code";
const NA = "--";

const SECTION_ALL = 1;
const SECTION_ACTIVE = 2;
const SECTION_IN_ACTIVE = 3;
const SECTION_APP = 4;

const LABEL_ALL = "ALL";
const LABEL_ACTIVE = "ACTIVE";
const LABEL_INACTIVE = "INACTIVE";
const LABEL_APP = "APP";

const restricted_access = localStorage.getItem("restricted_access");

const customDateLabel = () => {
  const style = {
    sub: {
      margin: "0px 40px",
      fontSize: "12px",
      color: "#444445",
      marginTop: "500px"
    },
    main: {
      margin: "0px"
    },
    wrapper: {
      margin: "0px"
    }
  };
  return (
    <p style={style.wrapper}>
      <sub style={style.sub}>From</sub>
      <span style={style.main}>Date</span>
      <sub style={{ ...style.sub, ...{ marginLeft: 70, marginRight: 55 } }}>To</sub>
    </p >
  );
};

const labels = [
  "Promocode",
  customDateLabel(),
  "Gyms",
  "Usage",
  "Type",
  "Status",
  "Actions",
];

const style = {
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: "30px",
    paddingBottom: "30px"
  },
  container: {
    width: "90%",
    height: 120,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end"
  },
  input: {
    width: "100%",
    border: "1px solid hsl(0,0%,80%)",
    margin: "5px 0px",
    height: "45px",
    padding: "2px 10px",
    boxSizing: "border-box",
    color: "#454545",
    fontSize: "14px",
    borderRadius: "5px",
    backgroundColor: "#fafafa"
  },
  titleWrapper: {
    display: "flex"
  },
  titleItem: {
    flex: "1",
    fontSize: "20px",
    color: "#00b4d2"
  },
  notificationButton: {
    height: "65px",
    width: "200px",
    backgroundColor: "#00b4d2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    cursor: "pointer",
    margin: "50px",
    marginTop: "0px",
    borderRadius: "40px",
    marginRight: "0px",
    fontSize: "18px"
  },
  createButton: {
    width: "150px",
    fontSize: "18px",
    margin: "50px",
    marginTop: "0px",
    marginLeft: "20px",
    marginRight: "0px",
  },
  createNotification: {
    height: "50px",
    width: "200px",
    backgroundColor: "#00b4d2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    cursor: "pointer"
  }
};

const PromocodesScreen = props => {
  return (
    <div>
      <Router>
        <Switch>
          <Route exact={true} path="/promocodes/" component={PromoCodes} />
          <Route exact={true} path="/promocodes/create" component={CreatePromocode} />
          <Route exact={true} path="/promocodes/users" component={Users} />
          <Route exact={true} path="/promocodes/users/user" component={SingleUser} />
        </Switch>
      </Router>
    </div>
  );
};

export default PromocodesScreen;

const headerItems = labels.map((label, i) => {
  return (
    <p style={style.titleItem} key={i}>
      {label}
    </p>
  );
});

const header = () => <div style={style.titleWrapper}>{headerItems}</div>;

class PromoCodes extends React.Component {

  constructor(props) {
    super(props);
    let storedState = localStorage.getItem(Constants.STATE_PROMOCODES);
    if (storedState)
        storedState = JSON.parse(storedState);
    this.state = storedState ? storedState : {
      promos: [],
      filteredPromos: [],
      newNotificationHeading: "",
      newNotificationText: "",
      newNotificationImage: null,
      showNotificationModal: false,
      newNotificationImageFileName: "",
      selectedSection: SECTION_ALL,
      totalPages: 0,
      currentPage: 0,
      rowCount: Constants.DEFAULT_PAGINATION_COUNT,
      searchQuery: null,
    };
  }

  componentDidMount() {
    this.getPromoCodes();
  }

  componentWillUnmount() {
    localStorage.setItem(Constants.STATE_PROMOCODES, JSON.stringify(this.state));
}


  renderSection = (sectionID, title) => <div className={`unselectable section ${this.state.selectedSection == sectionID ? "section-active" : ""}`} onClick={() => {
    if (this.state.selectedSection != sectionID) {
      this.setState({
        selectedSection: sectionID
      }, () => {
        // Fetch user details for selected tab.
        this.getPromoCodes();
      })
    }
  }}>
    <div className={`label ${this.state.selectedSection == sectionID ? "label-active" : ""}`}>{title.toUpperCase()}</div>
  </div>

  getQueryParams() {
    let query = "";
    switch (this.state.selectedSection) {
      case SECTION_ACTIVE:
        query = "status=active";
        break;
      case SECTION_IN_ACTIVE:
        query = "status=inactive";
        break;
      case SECTION_APP:
        query = "app=true";
        break;
    }
    return query;
  }

  getPromoCodes() {
    if(this.state.currentPage < 0) return
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Fetching Promocodes...");
    let url =  "promos?pagination=true&cpp=" + this.state.rowCount + "&index=" + this.state.currentPage
    if(this.state.searchQuery) {
      url = url + "&search=" + encodeURIComponent(this.state.searchQuery)
    }
    if(this.getQueryParams()) {
      url = url + "&" + this.getQueryParams()
    }
    axios
      .get(`${API_URL}/${url}`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        this.setState({
          ...this.state,
          promos: res.data.data,
          totalPages: res.data.pagination ? res.data.pagination.total : 0
        }, () => this.setState({ filteredPromos: this.state.promos }));
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  deletePromoCode(promo_id) {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Deleting Promocode...");
    axios
      .delete(`${API_URL}/promos/${promo_id}`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        this.removePromoCode(promo_id)
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  removePromoCode(promoId) {
    //Remove promo from promos array
    const promoIndex = this.state.promos.findIndex(promo => promo.promo_id === promoId);
    const promos = [...this.state.promos]; // make a separate copy of the array
    if (promoIndex !== -1) {
      promos.splice(promoIndex, 1);
      this.setState({
        promos
      });
    }

    //Remove promo from filteredPromos array
    const filteredPromoIndex = this.state.filteredPromos.findIndex(promo => promo.promo_id === promoId);
    const filteredPromos = [...this.state.filteredPromos]; // make a separate copy of the array
    if (filteredPromoIndex !== -1) {
      filteredPromos.splice(filteredPromoIndex, 1);
      this.setState({
        filteredPromos
      });
    }
  }

  sendNotification = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Sending Notification...");
    let data = new FormData();
    let {
      newNotificationImage,
      newNotificationText,
      newNotificationHeading
    } = this.state;
    console.log(newNotificationImage);
    if (newNotificationImage) data.append("image", newNotificationImage);
    else {
      console.log("image not in state");
    }
    data.append(
      "payload",
      JSON.stringify({
        topic: "general",
        payload: {
          notification: {
            title: newNotificationHeading,
            body: newNotificationText
          } /* ,
        data: {
          off: "30%",
          code: "hela"
        } */
        }
      })
    );
    axios
      .post(`${API_URL}/admin/sendPushNotification`, data, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(response => {
        toast.dismiss(toastId);
        this.setState({
          showNotificationModal: false,
          newNotificationImageFileName: "",
          newNotificationImage: null
        });
        toast.success("Notification Sent", {
          autoClose: 1500
        });
        console.log(response);
      })
      .catch(err => {
        this.setState({
          showNotificationModal: false,
          newNotificationImageFileName: "",
          newNotificationImage: null
        });
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  };



  searchHandler = e => {

    if(this.timeOut) clearTimeout(this.timeOut) // Hit api only if there is no event for 500 ms
    this.setState({
      ...this.state,
      currentPage: 0,
      searchQuery: e.target.value.toLowerCase()
    }, () => {
      this.timeOut = setTimeout(()=> {
        this.getPromoCodes() // Hit api only if there is no event for 500 ms
        this.timeOut = null
      }, 500);
    });
  };

  render() {
    const { totalPages } = this.state;
    const rowCount = parseInt(this.state.rowCount)
    return (
      <div
        style={style.rootContainer}
      >
        <div
          style={style.container}
        >
          <SearchBox style={{ alignItems: "flex-start" }} onChange={this.searchHandler} value={this.state.searchQuery}/>
          <div
            style={style.notificationButton}
            onClick={() => {
              this.setState({ showNotificationModal: true });
            }}
          >
            Send Notification
          </div>
          <Link to="/promocodes/create">
            <Button
              type="primary"
              style={style.createButton}
            >
              Create
            </Button>
          </Link>
          {restricted_access == 'false' &&
            <Button
              onClick={this.exportAppliedPromos}
              type="primary"
              style={{ ...style.createButton, width: "220px" }}>
              Export Applied Promos
            </Button>}
          {restricted_access == 'false' &&
            <Button
              onClick={this.exportAppliedPackages}
              type="primary"
              style={{ ...style.createButton, width: "220px" }}>
              Export Applied Packages
            </Button>}
          {restricted_access == 'false' && <Button
            onClick={this.exportPurchasedPackages}
            type="primary"
            style={{ ...style.createButton, width: "250px" }}>
            Export Purchased Packages
            </Button>}
        </div>
        <div className="section-container" style={{ alignSelf: 'center' }}>
          {this.renderSection(SECTION_ALL, LABEL_ALL)}
          {this.renderSection(SECTION_ACTIVE, LABEL_ACTIVE)}
          {this.renderSection(SECTION_IN_ACTIVE, LABEL_INACTIVE)}
          {this.renderSection(SECTION_APP, LABEL_APP)}
        </div>
        <Box
          outline
          style={{
            width: "1200px"
          }}
        >
          {header()}
          {this.promoCodeRows(this.state.filteredPromos)}
        </Box>
        <Pagination
          currentPage={this.state.currentPage}
          pageCount={totalPages}
          rowCount={rowCount}
          pageAction={pageNumber => {
            this.setState({ ...this.state, currentPage: pageNumber }, ()=>{
              this.getPromoCodes();
            });
          }}
          updateRowCount={(rowCount) => {
            this.setState({ rowCount, currentPage: 0 }, ()=>{
              this.getPromoCodes();
            });
          }}
        />
        {this.state.showNotificationModal && (
          <ModalOverlay
            header={<div style={{ margin: "10px" }}>Send Notification</div>}
            close={() => {
              this.setState({ showNotificationModal: false });
            }}
          >
            <div style={{ width: "700px", padding: "25px" }}>
              {/* <Select
                options={[{ label: "General", value: "general" }]}
                placeholder={"Notification Topic"}
                onChange={value => {
                  this.setState({ newNotificationType: value });
                }}
              /> */}
              <input
                type="text"
                placeholder={"Notification Heading"}
                style={style.input}
                value={this.state.newNotificationHeading}
                onChange={e => {
                  this.setState({ newNotificationHeading: e.target.value });
                }}
              />
              <input
                type="file"
                placeholder={"Notification Heading"}
                style={style.input}
                value={this.state.newNotificationImageFileName}
                onChange={e => {
                  this.setState({
                    newNotificationImage: e.target.files[0],
                    newNotificationImageFileName: e.target.value
                  });
                }}
              />
              <textarea
                placeholder={"Notification Text"}
                style={{
                  ...style.input,
                  ...{
                    height: "345px",
                    padding: "5px 10px",
                    resize: "none"
                  }
                }}
                value={this.state.newNotificationText}
                onChange={e => {
                  this.setState({ newNotificationText: e.target.value });
                }}
              />
              <div style={{ display: "flex", justifyContent: "flex-start" }}>
                <div
                  style={style.createNotification}
                  onClick={() => {
                    this.sendNotification();
                  }}
                >
                  Send Notification
                </div>
                <div
                  style={{
                    ...style.createNotification,
                    ...{
                      backgroundColor: "#a0b4d2",
                      marginLeft: "10px"
                    }
                  }}
                  onClick={() => {
                    this.setState({ showNotificationModal: false });
                  }}
                >
                  Close
                </div>
              </div>
            </div>
          </ModalOverlay>
        )}
      </div>
    );
  }

  exportAppliedPromos = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Applied Promos...");
    axios
      .get(`${API_URL}/admin/export/applied_promos`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "applied_promos_all.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  exportAppliedPackages = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Applied Promos...");
    axios
      .get(`${API_URL}/admin/export/applied_promos/?only_packages=true`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "applied_packages_all.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  exportPurchasedPackages = () => {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Exporting Purchased Packages...");
    axios
      .get(`${API_URL}/admin/export/purchased_packages`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        DOWNLOAD(res.data, "export_purchased_packages.csv");
        toast.dismiss(toastId);
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  };

  getStatusTextColour(status, toDate) {
    return status ? dateDiffInDays(new Date(), toDate) < 7 ? theme.color.orange : theme.color.lightGreen : theme.color.red
  }

  promoCodeRows = promos =>
    promos.map((currentItem, i) => {
      const style = {
        itemWrapper: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
        },
        item: {
          flex: 1
        },
        editButton: {
          width: "77px",
          height: "29px",
          fontSize: "16px",
          color: "#414141",
          marginRight: "5px",
          border: "solid 2px " + theme.color.primaryBlue
        },
        deleteButton: {
          width: "77px",
          height: "29px",
          fontSize: "16px",
          color: "#414141",
          marginLeft: "5px",
          border: "solid 2px " + theme.color.red
        },
        deleteButtonContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      };
      return (
        <div key={i} onClick={() => {
          this.props.history.push('/promocodes/users', { promoId: currentItem.promo_id })
        }}>
          <hr style={{ borderTop: "1px solid #b5b5b6", borderRadius: "0.5px" }} />
          <div style={style.itemWrapper}>
            <p style={{ ...style.item }}>
              {String(currentItem.promocode).toUpperCase()}
            </p>
            <p style={{ ...style.item }}>
              {currentItem.from ? moment(currentItem.from).format("MM/DD/YYYY") : NA}
            </p>
            <p style={{ ...style.item }}>
              {currentItem.to ? moment(currentItem.to).format("MM/DD/YYYY") : NA}
            </p>
            <p style={{ ...style.item }}>{currentItem.gyms}</p>
            <p style={{ ...style.item }}>{currentItem.usage}</p>
            <p style={{ ...style.item, flexBasis: "3%" }}>{currentItem.class}</p>
            <div style={{ flex: 1 }}>
              <p style={{ ...style.item, ... { color: this.getStatusTextColour(currentItem.status, currentItem.to) } }}>
                {currentItem.status ? AVAILABLE_TEXT : UN_AVAILABLE_TEXT}</p>
              {currentItem.status && currentItem.to && <p style={{ ...style.item }}>
                {getExpiryDuration(currentItem.to)}
              </p>}
            </div>
            <div style={style.deleteButtonContainer}>
              <Button
                type="holo"
                holo
                style={{ ...style.editButton }}
                onClick={(event) => {
                  event.stopPropagation();
                  this.props.history.push('/promocodes/create', { promoId: currentItem.promo_id })
                }}
              >
                {EDIT_TEXT}
              </Button>
              {restricted_access == 'false' && <Button
                type="holo"
                holo
                style={{ ...style.deleteButton }}
                onClick={(event) => {
                  event.stopPropagation();
                  submit(DELETE_ALERT_TEXT, () => {
                    this.deletePromoCode(currentItem.promo_id);
                  })
                }}
              >
                {DELETE_TEXT}
              </Button>}
            </div>
          </div>
        </div >
      );
    });
}
